import helpers from 'src/helpers'
export default {
  esacPointsVoucherList: state => {
    return state.voucherList
  },
  esacPointsRedemptionList: state => {
    return state.redemptionList
  },
  esacPointsRedemptionData: state => {
    return state.redemption.data
  },
  esacPointsBalance: state => {
    return state.balance
  },
  getEsacPointsAdditionalAttributesInvalidRowStatus: state => (key, id) => {
    let existIndex = state.cartAdditionalAttributesInCompleteIds[key].findIndex(x => x === id)
    return existIndex !== -1
  },
  cartHasIncompleteAdditionalAttributesIds: state => {
    if (
      state.cartAdditionalAttributesInCompleteIds.product_ids.length > 0 ||
      state.cartAdditionalAttributesInCompleteIds.kitting_ids.length > 0
    ) {
      return true
    }
    return false
  },
}
